import React, {Component} from 'react'
import {Card, CardActions, CardContent, Grid, IconButton, Typography} from '@material-ui/core';
import {Add} from '@material-ui/icons';
import localization from '../../../config/localization';
import HomeBannerElement from './HomeBannerElement';
import HomeBannerElementForm from './HomeBannerElementForm';
import {request} from '../../../api-client';
import GlobalConfirmationDialog from '../../../components/Letflow/Dialog/GlobalConfirmationDialog';
import FormControl from "@material-ui/core/FormControl";

class HomeBanners extends Component {

  constructor(props) {
    super(props)
    this.state = {
      banners: props.items || [],
      showForm: false
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({banners: nextProps.items})
  }

  makeBannerForm = () => this.state.showForm &&
    <HomeBannerElementForm
      formTitle={localization.get('form.title')}
      onClose={() => this.setState({ showForm: false })}
      submitRequest={(active, title, subtitle, link, newTab, image, video, preview, embedUrl, translations, onProgress) =>
        request.home.createBannerItem(
          this.props.id,
          { active, title, subtitle, link, newTab, image, video, preview, embedUrl, sectionId: this.props.sectionId, translations },
          onProgress
        ).then(this.props.onUpdateSuccess).catch(this.props.onUpdateFailed)
      }
    />

  requestDelete = () => request.home.delete(this.props.id).then(this.props.onUpdateSuccess).catch(this.props.onUpdateFailed)

  handleDelete = () => GlobalConfirmationDialog.showDelete({ elementName: 'Banner', deleteRequest: this.requestDelete })

  render = () =>
    <React.Fragment>
      <FormControl fullWidth>
        <Card style={{ width: '100%' }}>
          {this.makeBannerForm()}
          <CardContent>
            <Typography variant='display1'>{localization.get('home_editor.banners')}</Typography>
            <Grid style={{ marginTop: '20px' }} spacing={16} container>
              {this.state.banners.length === 0 && <Typography>{localization.get('home_editor.banners_element_empty')}</Typography>}
              {this.state.banners.map((banner, i) => <Grid xs={12} sm={6} md={4} item><HomeBannerElement {...this.props} banner={banner}  elementId={this.props.id} itemIndex={i} /></Grid>)}
            </Grid>
          </CardContent>
          <CardActions style={{ float: 'right' }}>
            <IconButton onClick={() => this.setState({ showForm: true })}><Add /></IconButton>
          </CardActions>
        </Card>
      </FormControl>
    </React.Fragment>
}

export default HomeBanners